import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import Button, {ButtonScale, ButtonVariant} from 'components/Button';
import {BlockTitle} from '../components/styled';
import {TeacherItem} from '../types';
import {CoursePromoContext} from '../context';

const Container = styled.div`
  padding: 0 30px 0 60px;

  @media screen and (max-width: 760px) {
    padding: 0 16px;
  }
`;

const Title = styled(BlockTitle)`
  margin-bottom: 40px;
`;

const Item = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 268px;
  margin-left: 30px;
  margin-bottom: 30px;
  padding: 30px 15px;
  border-radius: 5px;
  background: ${({theme}) => `
    ${theme.variables.accentBackgroundColor};
  `};

  @media screen and (max-width: 760px) {
    margin-left: 11px;
    margin-bottom: 11px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -30px;
  margin-bottom: -30px;

  @media screen and (max-width: 760px) {
    margin-left: -11px;
    margin-bottom: -11px;
  }
`;

const Avatar = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
`;

const Name = styled.div`
  max-width: 228px;
  margin-top: 16px;
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: 600;
  line-height: 29px;
  text-align: center;
`;

const Role = styled.div`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  color: ${({theme}) => `
    ${transparentize(.2, theme.colors.white)};
  `};
`;

/**
 * The returns course teachers component
 * @return {React.ReactElement}
 * @constructor
 */
export default function Teachers(): React.ReactElement{
  const {teachers} = React.useContext(CoursePromoContext);

  /**
   * Render course teacher item
   * @param {TeacherItem} teacher
   * @param {number} ind
   * @constructor
   */
  function renderTeacher(teacher: TeacherItem, ind: number): JSX.Element {
    const {name, role, imgSrc} = teacher;

    return (
      <Item key={teacher.toString() + ind}>
        <Avatar
          src={imgSrc}
          alt="аватар"
        />
        <Name>{name}</Name>
        <Role>{role}</Role>
        <Button
          variant={ButtonVariant.Outline}
          scale={ButtonScale.Small}
        >
          подробнее
        </Button>
      </Item>
    );
  }

  return (
    <Container>
      <Title>Преподаватели курса</Title>
      <Content>
        {teachers.map(renderTeacher)}
      </Content>
    </Container>
  );
}
